import React, { useContext } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import { Divider } from 'karrierhub-ui/dist/common/src/components/MenuItem'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

import AppContext from '../../App/context'
import Form from '../../Form'

import style from './style.css'
import AccountContext from '../context'

import Social from '../Signup/social'

function Login(props) {

    const accountContext = useContext(AccountContext)
    const { name, parentRoute } = accountContext

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)
    const utils = getUtils(context)

    const { wapp, req } = context

    const query = req.wappRequest.query

    async function onSubmit(e, formData) {
        let response = await utils.login({
            requestName: name + 'Login',
            args: formData,
            ...typeof props.redirect !== 'undefined' && props.redirect !== parentRoute + '/logout' ?
                {
                    redirect: props.redirect
                } : {
                    redirect: {
                        pathname: query.redirect && query.redirect !== parentRoute + '/logout' ? query.redirect : appContext.routes.userRoute + '/:_id',
                        search: '',
                        hash: ''
                    }
                }
        })
        if (props.onSubmit) {
            const newResponse = await props.onSubmit(e, response)
            if (newResponse) {
                return newResponse
            }
        }
        return response
    }

    let formDataFromResolvers = {}
    try {
        formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'Login.formData')
    } catch (e) {
        console.log(e)
    }

    const formData = {
        ...formDataFromResolvers,
        submit: {
            label: appContext.labels.loginSubmitLabel,
            fullWidth: true,
            size: 'input-' + props.size,
            TypographyProps: {
                variant: 'button-' + props.size
            }
        }
    }

    formData['record.col1'] = {
        isContainer: true,
        hiddenContainer: true
    }

    formData['email'].transformValue = (value) => {
        if (value) {
            value = value.trim()
        }
        return value
    }
    formData['email'].enableUpdateValueAfterTransform = true

    wapp.styles.use(style)

    return (
        <div className={style.login}>
            <Form formData={formData} onSubmit={onSubmit} size={props.size} />
            <Button
                className={style.forgotPasswordButton}
                variant={'text'}
                label={appContext.menus.forgotPasswordMenu}
                href={parentRoute + '/forgotpassword'}
                size={props.size}
                fullWidth={true}
            />
            <Divider />
            <Social {...props} />
            <Button
                color={'tertiary'}
                href={parentRoute + '/signup' + (query.redirect ? '?redirect=' + encodeURIComponent(query.redirect) : '')}
                size={props.size}
                fullWidth={true}
            >
                <div className={style.signupButtonLabel}>
                    <Typography Component={'div'} variant={'subtitle2'}>{appContext.labels.signupQuestion}</Typography>
                    <div>{appContext.labels.nextToSignup}</div>
                </div>
            </Button>
        </div>

    )
}

export default withWapp(Login)
